module.exports = __webpack_public_path__ + "static/media/ck.0e4eaabf.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/ck.svg
// module id = 1206
// module chunks = 0